import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import api from '../services/api';
export default function RefreshStatus() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const load = async () => {
    setLoading(true); setError('');
    try { const response = await api.get('/admin/scheduler/status'); setData(response.data); }
    catch (_) { setError('Could not load scheduled refresh status.'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);
  const latest = data?.latest;
  const result = latest?.result;
  const stale = latest && (Date.now() - new Date(latest.started_at).getTime()) > 26 * 3600000;
  const interrupted = latest && !latest.finished_at && (Date.now() - new Date(latest.started_at).getTime()) > 2 * 3600000;
  return <Card><CardHeader><CardTitle>Scheduled keyword refresh</CardTitle>
    <CardDescription>Checks daily at 06:00 UTC. Each keyword keeps its configured frequency and 24-hour cooldown.</CardDescription></CardHeader>
    <CardContent className="space-y-3 text-sm">
      {error && <p role="alert">{error}</p>}
      {data && <>
        <p>Scheduler: <strong>{data.status.isRunning ? 'Enabled' : 'Disabled'}</strong></p>
        {!latest ? <p>No batch recorded yet. History starts with the next scheduled refresh.</p> : <>
          <p>Last started: {new Date(latest.started_at).toLocaleString()}</p>
          <p>{latest.finished_at ? `Finished: ${new Date(latest.finished_at).toLocaleString()}` : interrupted ? 'The last batch did not record a finish. It may have been interrupted.' : 'Batch is running.'}</p>
          {latest.finished_at && <p>{result.successful || 0} successful · {result.failed || 0} failed · {result.skipped || 0} skipped · {result.eligible || 0} eligible</p>}
          {result?.stopped && <p role="status">Stopped: {result.reason}. Remaining eligible keywords are considered on the next daily check.</p>}
          {stale && <p role="alert" className="text-amber-700">No daily check recorded in the last 26 hours.</p>}
        </>}
        <p className="text-muted-foreground">An answer without citations is recorded as a failed keyword and the batch continues. Billing, budget and system errors stop the batch.</p>
      </>}
      <Button variant="outline" size="sm" disabled={loading} onClick={load}>{loading ? 'Checking…' : 'Check status'}</Button>
    </CardContent></Card>;
}
